import docConse from "../doc/9fd05bcc-0011-45a4-9631-25e9bbd3086b.pdf";
import docCodPrac from "../doc/1febb88b-b8c9-42b2-8dcb-0a19103c4d82.pdf";
import docAvisoPriv from "../doc/4d86f18b-d76e-4fe8-8e59-19e798c18cc3.pdf";
import docColbMaterias from "../doc/73a98fdf-a20c-48e4-b1d2-1bbe2fce138c.pdf";
import docCartaDerechos from "../doc/905af154-ddbf-43a5-9afa-aad26f92fb61.pdf";
import docContratoAdhesion from "../doc/30de5188-b089-428f-944a-5b182478c93f.pdf";

const Transparencia = [
  {
    id: 1,
    title: "Aviso de privacidad",
    url: docAvisoPriv,
  },
  {
    id: 2,
    title: "Aviso de colaboración en materia de seguridad y justicia",
    url: docColbMaterias,
  },
  {
    id: 3,
    title: "Carta de derechos mínimos",
    url: docCartaDerechos,
  },
  {
    id: 4,
    title: "Código de Prácticas Comerciales",
    url: docCodPrac,
  },
  {
    id: 5,
    title: "Concesión",
    url: docConse,
  },
  {
    id: 6,
    title: "Contrato Adhesión Profeco",
    url: docContratoAdhesion,
  },
];

export default Transparencia;
